import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      auth: false
    }
  },
  {
    path: '/demo',
    name: 'Demo',
    component: () => import('../views/demo/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/account/login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: () => import('../views/product/detail.vue'),
    meta: {
      title: '我的'
    }
  },
  {
    path: '/productlist',
    name: 'ProductList',
    component: () => import('../views/product/list.vue'),
    meta: {
      title: '商品列表'
    }
  },
  {
    path: '/cart',
    name: 'CartHome',
    component: () => import('../views/cart/index.vue')
  },
  {
    path: '/integral',
    component: () => import('../views/integral/index.vue'),
    meta: {
      auth: false,
      title: '能量商城'
    },
    children: [
      {
        path: 'pay',
        name: 'integralPay',
        component: () => import('../views/integral/pay.vue')
      }
    ]
  },
  {
    path: '/order',
    component: () => import('../views/order/index.vue'),
    meta: {
      auth: true,
      title: '订单'
    },
    children: [
      {
        path: '',
        name: 'OrderHome',
        component: () => import('../views/order/home.vue')
      },
      {
        path: 'detail',
        name: 'OrderDetail',
        component: () => import('../views/order/detail.vue')
      },
      {
        path: 'additional',
        name: 'OrderAdditional',
        component: () => import('../views/order/additional.vue')
      },
      {
        path: 'pay',
        name: 'OrderPay',
        component: () => import('../views/order/pay.vue')
      },
      {
        path: 'payinfo',
        name: 'OrderPayInfo',
        component: () => import('../views/order/pay-info.vue')
      }
    ]
  },
  {
    path: '/activity',
    component: () => import('../views/order/index.vue'),
    children: [
      {
        path: 'caoyuan',
        name: 'caoyuan',
        component: () => import('../views/activity/caoyuan.vue')
      },
      {
        path: 'pay',
        name: 'caoyuan_pay',
        component: () => import('../views/activity/pay.vue')
      },
      {
        path: 'sccuess',
        name: 'caoyuan_sccuess',
        component: () => import('../views/activity/sccuess.vue')
      }
    ]
  },
  {
    path: '/my',
    name: 'MyHome',
    component: () => import('../views/my/index.vue'),
    meta: {
      auth: true,
      title: '我的'
    }
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/help/index.vue'),
    meta: {
      title: '帮助'
    }
  }
]

export default routes
